import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { temporaryLoyaltyDomainStore } from '../../../temporary-store/store';
import { MemberJourneyListType } from '../../../types/member-journey-list-type';
export const memberHasMoreJourneyResults = (type) => {
    if (type === MemberJourneyListType.Active || type === MemberJourneyListType.NextJourney)
        return false;
    const journeys = getFetchedDataPayload(temporaryLoyaltyDomainStore.data.memberJourneys.past);
    return journeys ? journeys.hasMoreResults : false;
};
